import styled from 'styled-components';
import { SCREEN } from 'lib/constants';
import { COLORS } from 'lib/theme';
import bamboo from 'assets/images/bamboo1.png';

export default styled.div`
  background-color: ${COLORS.dark};
  background-image: url(${bamboo});
  background-repeat: no-repeat;
  background-size: cover;
  height: ${SCREEN.height}px;
  width: ${SCREEN.width}px;
  overflow: hidden;
  padding-right: 4rem;
`;
